import { createAction } from 'redux-actions-helpers'
import { BlockType, LinkItemType } from '../LessonPage/types'

export const fetchBlock = createAction(
  '@@admin-block-edit/FETCH_BLOCK',
  (block_id: string): any => ({ block_id })
)

export const fetchBlockSuccess = createAction(
  '@@admin-block-edit/FETCH_BLOCK_SUCCESS',
  (result: BlockType): any => ({ result })
)

export const fetchBlockFailure = createAction(
  '@@admin-block-edit/FETCH_BLOCK_FAILURE',
  (error: string): any => ({ error })
)

export const fetchLinks = createAction('@@admin-block-edit/FETCH_LINKS')

export const fetchLinksSuccess = createAction(
  '@@admin-block-edit/FETCH_LINKS_SUCCESS',
  (result: LinkItemType[]): any => ({ result })
)

export const fetchLinksFailure = createAction(
  '@@admin-block-edit/FETCH_LINKS_FAILURE',
  (error: string): any => ({ error })
)

export const createLink = createAction(
  '@@admin-block-edit/CREATE_LINK',
  (data: object): any => ({ data })
)

export const createLinkSuccess = createAction(
  '@@admin-block-edit/CREATE_LINK_SUCCESS'
)

export const createLinkFailure = createAction(
  '@@admin-block-edit/CREATE_LINK_FAILURE',
  (error: string): any => ({ error })
)

export const assignLinksToBlock = createAction(
  '@@admin-block-edit/ASSIGN_LINKS_TO_BLOCK',
  (block_id: string, block_link_id: string, links: string[]): any => ({
    block_id,
    block_link_id,
    links,
  })
)

export const assignLinksToBlockSuccess = createAction(
  '@@admin-block-edit/ASSIGN_LINKS_TO_BLOCK_SUCCESS'
)

export const assignLinksToBlockFailure = createAction(
  '@@admin-block-edit/ASSIGN_LINKS_TO_BLOCK_FAILURE',
  (error: string): any => ({ error })
)

export const uploadFiles = createAction(
  '@@admin-block-edit/UPLOAD_FILES',
  (files: File[]): any => ({ files })
)

export const uploadFilesSuccess = createAction(
  '@@admin-block-edit/UPLOAD_FILES_SUCCESS',
  (result: string[]): any => ({ result })
)

export const uploadFilesFailure = createAction(
  '@@admin-block-edit/UPLOAD_FILES_FAILURE',
  (error: string): any => ({ error })
)

export const uploadedFilesDestroy = createAction(
  '@@admin-block-edit/UPLOADED_FILES_DESTROY'
)

export const assignFilesToBlock = createAction(
  '@@admin-block-edit/ASSIGN_FILES_TO_BLOCK',
  (block_id: string, block_file_id: string, files: string[]): any => ({
    block_id,
    block_file_id,
    files,
  })
)

export const assignFilesToBlockSuccess = createAction(
  '@@admin-block-edit/ASSIGN_FILES_TO_BLOCK_SUCCESS'
)

export const assignFilesToBlockFailure = createAction(
  '@@admin-block-edit/ASSIGN_FILES_TO_BLOCK_FAILURE',
  (error: string): any => ({ error })
)

export const fetchVideos = createAction('@@admin-block-edit/FETCH_VIDEOS')

export const fetchVideosSuccess = createAction(
  '@@admin-block-edit/FETCH_VIDEOS_SUCCESS',
  (result: any): any => ({ result })
)

export const fetchVideosFailure = createAction(
  '@@admin-block-edit/FETCH_VIDEOS_FAILURE',
  (error: string): any => ({ error })
)

export const createVideo = createAction(
  '@@admin-block-edit/CREATE_VIDEO',
  (caption: string, preview_image_url: string, url: string): any => ({
    caption,
    preview_image_url,
    url,
  })
)

export const createVideoSuccess = createAction(
  '@@admin-block-edit/CREATE_VIDEO_SUCCESS'
)

export const createVideoFailure = createAction(
  '@@admin-block-edit/CREATE_VIDEO_FAILURE',
  (error: string): any => ({ error })
)

export const assignVideosToBlock = createAction(
  '@@admin-block-edit/ASSIGN_VIDEOS_TO_BLOCK',
  (block_id: string, block_video_id: string, videos: string[]): any => ({
    block_id,
    block_video_id,
    videos,
  })
)

export const assignVideosToBlockSuccess = createAction(
  '@@admin-block-edit/ASSIGN_VIDEOS_TO_BLOCK_SUCCESS'
)

export const assignVideosToBlockFailure = createAction(
  '@@admin-block-edit/ASSIGN_VIDEOS_TO_BLOCK_FAILURE',
  (error: string): any => ({ error })
)

export const assignGalleryToBlock = createAction(
  '@@admin-block-edit/ASSIGN_GALLERY_TO_BLOCK',
  (block_id: string, block_gallery_id: string, images: string[]): any => ({
    block_id,
    block_gallery_id,
    images,
  })
)

export const assignGalleryToBlockSuccess = createAction(
  '@@admin-block-edit/ASSIGN_GALLERY_TO_BLOCK_SUCCESS'
)

export const assignGalleryToBlockFailure = createAction(
  '@@admin-block-edit/ASSIGN_GALLERY_TO_BLOCK_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@admin-block-edit/DESTROY')
